  import React from "react";
  import Form12ApplicaionFormatView from './Form12ApplicationView'
  import {Loader} from "@egovernments/digit-ui-react-components";
  
  
  const Form12SummaryView = ({ formData, collectionBillDetails, edcrDetails}) => {
  
    const stateId = Digit.ULBService.getStateId();
    const appType = formData?.applicationType;
    const BusinessService = (formData?.businessService === `BPA_${appType?.replace("_", "")}`) ? `BPA.${appType}_FEE` : `BPA.${appType}_FEE_UD`;
    // const {
    //   nocDocuments,
    //   PrevStateDocuments,
    //   PrevStateNocDocuments,
    // } = formData;
   
    const docs = formData?.documents || {};
    const documents = typeof docs === 'object' && !Array.isArray(docs) ? Object.values(docs) : docs;
    formData.documents = documents;
    // let user = Digit.UserService.getUser();
    // const userRoles = user?.info?.roles?.map((e) => e.code);
    // let isbelow = formData?.applicationData?.plotArea < 2500
    // const isTCP = userRoles.includes("TCP_HQ")
    // let actions = workflowDetails?.data?.actionState?.nextActions?.filter((e) => {
    //   if (isbelow && isTCP && e.action === "SEND_TO_STP" && formData?.businessService === "BPA") {
    //     return false;
    //   }
    //   else if (!isbelow && isTCP && (e.action === "APPROVE" || e.action === "APPROVAL_LETTER_GENERATE" || e.action === "REJECT") && formData?.businessService === "BPA") {
    //     return false
    //   }
    //   return userRoles.some((role) => e.roles?.includes(role)) || !e.roles;
    // });
    //
    
  
    
    let improvedDoc = [];
    formData?.PrevStateDocuments?.map(preDoc => { improvedDoc.push({ ...preDoc, module: "OBPS" }) });
    formData?.documents?.map(appDoc => { improvedDoc.push({ ...appDoc, module: "OBPS" }) });
  
    formData?.PrevStateNocDocuments?.map(preNocDoc => { improvedDoc.push({ ...preNocDoc, module: "NOC" }) });
    formData?.nocDocuments?.nocDocuments?.map(nocDoc => { improvedDoc.push({ ...nocDoc, module: "NOC" }) });
  
    const { data: pdfDetails, isLoading: pdfLoading } = Digit.Hooks.useDocumentSearch(improvedDoc, { enabled: improvedDoc?.length > 0 ? true : false });
  
    let applicationDocs = [], nocAppDocs = [];
    if (pdfDetails?.pdfFiles?.length > 0) {
      pdfDetails?.pdfFiles?.map(pdfAppDoc => {
        if (pdfAppDoc?.module == "OBPS") applicationDocs.push(pdfAppDoc);
        if (pdfAppDoc?.module == "NOC") nocAppDocs.push(pdfAppDoc);
      });
    }
  
    let consumerCode = formData?.applicationNo;
    const fetchBillParams = { consumerCode };
  
    const { data: paymentDetails } = Digit.Hooks.useFetchBillsForBuissnessService(
      { businessService: BusinessService, ...fetchBillParams, tenantId: stateId },
      {
        enabled: consumerCode ? true : false,
        retry: false,
      }
    );
    const totalAmount = formData?.taxHeadEstimates?.[0]?.estimateAmount 
    // formData?.paymentDetails?.bill?.billDetails[0]?.amount || paymentDetails?.Bill?.[0]?.billDetails[0]?.amount
  
    // const handleChange = (event, newValue) => {
    //   setCurrentTab(newValue);
    // };
    const isEditApplication = window.location.href.includes("editApplication");
    const sendbacktocitizenApp = window.location.href.includes("sendbacktocitizen");
    let routeLink = `/digit-ui/citizen/obps/form11/${formData?.applicationType?.toLowerCase()}/${formData?.serviceType?.toLowerCase()}`;
    if (isEditApplication) routeLink = `/digit-ui/citizen/obps/editApplication/form11/${formData?.tenantId}/${formData?.applicationNo}`;
    if (sendbacktocitizenApp) routeLink = `/digit-ui/citizen/obps/sendbacktocitizen/form11/${formData?.tenantId}/${formData?.applicationNo}`;
    ////
    function OpenImage(imageSource, index, thumbnailsToShow) {
      window.open(thumbnailsToShow?.fullImage?.[0], "_blank");
    }
    // const getTimelineCaptions = (checkpoint) => {
    //   if (checkpoint.state === "OPEN" || checkpoint.status === "INITIATED" && !(window.location.href.includes("/obps/"))) {
    //     const caption = {
    //       date: Digit.DateUtils.ConvertTimestampToDate(applicationData?.auditDetails?.createdTime),
    //       source: applicationData?.channel || "",
    //     };
    //     return <TLCaption data={caption} />;
    //   }
    //   else if (window.location.href.includes("/obps/") || window.location.href.includes("/noc/")) {
    //     const caption = {
    //       date: checkpoint?.auditDetails?.lastModified,
    //       name: checkpoint?.assignes?.[0]?.name,
    //       mobileNumber: checkpoint?.assignes?.[0]?.mobileNumber,
    //       comment: t(checkpoint?.comment),
    //       wfComment: checkpoint.wfComment,
    //       thumbnailsToShow: checkpoint?.thumbnailsToShow,
    //     };
    //     return <TLCaption data={caption} OpenImage={OpenImage} />;
    //   }
    //   else {
    //     const caption = {
    //       date: Digit.DateUtils?.ConvertTimestampToDate(applicationData?.auditDetails?.lastModifiedTime),
    //       name: checkpoint?.assignes?.[0]?.name,
    //       wfComment: checkpoint?.wfComment,
    //       mobileNumber: checkpoint?.assignes?.[0]?.mobileNumber,
    //     };
    //     return <TLCaption data={caption} />;
    //   }
    // };
    // function routeTo(jumpTo) {
    //   location.href = jumpTo;
    // }
  
    if (pdfLoading) {
      return <Loader />
    }
    ///////////////////////////////////
    const getInspectionDocs = (docs) => {
      let refinedDocs = [];
      docs && docs.map((doc, ind) => {
        refinedDocs.push({
          "documentType": (doc.documentType + "_" + doc.documentType.split("_")[1]).replaceAll("_", "."),
          "fileStoreId": doc.fileStoreId,
          "fileStore": doc.fileStoreId,
          "fileName": "",
          "dropDownValues": {
            "value": (doc.documentType + "_" + doc.documentType.split("_")[1]).replaceAll("_", "."),
          }
        })
      })
      return refinedDocs;
    }
  
    // const getQuestion = (data) => {
    //   let refinedQues = [];
    //   var i;
    //   for (i = 0; i < data?.questionLength; i++) {
    //     refinedQues.push({
    //       "remarks": data[`Remarks_${i}`],
    //       "question": data?.questionList[i].question,
    //       "value": data?.[`question_${i}`]?.code,
    //     })
    //   }
    //   return refinedQues;
    // }
  
    // const getfeildInspection = (data) => {
    //   let formdata = [], inspectionOb = [];
  
    //   if (data?.additionalDetails?.fieldinspection_pending?.length > 0) {
    //     inspectionOb = data?.additionalDetails?.fieldinspection_pending
    //   }
  
    //   if (data.status == "FIELDINSPECTION_INPROGRESS") {
    //     formdata = JSON.parse(sessionStorage.getItem("INSPECTION_DATA"));
    //     formdata?.length > 0 && formdata.map((ob, ind) => {
    //       inspectionOb.push({
    //         docs: getInspectionDocs(ob.Documents),
    //         date: ob.InspectionDate,
    //         questions: getQuestion(ob),
    //         time: ob?.InspectionTime,
    //       })
    //     })
    //     inspectionOb = inspectionOb.filter((ob) => ob.docs && ob.docs.length > 0);
    //   } else {
    //     sessionStorage.removeItem("INSPECTION_DATA")
    //   }
  
    //   let fieldinspection_pending = [...inspectionOb];
    //   return fieldinspection_pending;
    // }
  
    const getDocuments = () => {
      let documentsformdata = JSON.parse(sessionStorage.getItem("BPA_DOCUMENTS"));
      let documentList = [];
      documentsformdata?.map(doc => {
        if (doc?.uploadedDocuments?.[0]?.values?.length > 0) documentList = [...documentList, ...doc?.uploadedDocuments?.[0]?.values];
        if (doc?.newUploadedDocs?.length > 0) documentList = [...documentList, ...doc?.newUploadedDocs]
      });
      return documentList;
    }
  
    const getPendingApprovals = () => {
      const approvals = Digit.SessionStorage.get("OBPS_APPROVAL_CHECKS");
      const newApprovals = Digit.SessionStorage.get("OBPS_NEW_APPROVALS");
      let result = approvals?.reduce((acc, approval) => approval?.checked ? acc.push(approval?.label) && acc : acc, []);
      result = result?.concat(newApprovals !== null ? newApprovals.filter(ob => ob.label !== "").map(approval => approval?.label) : []);
      return result;
    }
  
  
  
    // function submit(data) {
    //   if (currentAction?.action === "APPROVAL_LETTER_GENERATE") {
    //     onActionSelect(currentAction)
    //     // setOnAddComments(developerRemarks)
    //   }
    //   else {
    //     // let workflow = { action: currentAction, comments: developerRemarks, businessService, moduleName: moduleCode };
    //     const additionalDetails = { ...applicationData?.additionalDetails, fieldinspection_pending: getfeildInspection(applicationData), pendingapproval: getPendingApprovals() || [] }
    //     const workflow = {
    //       action: currentAction?.action,
    //       comment: developerRemarks,
    //       comments: developerRemarks,
    //       assignee: null,
    //       assignes: null,
    //       // varificationDocuments: uploadedFile
    //       //     ? [
    //       //         {
    //       //             documentType: currentAction + " DOC",
    //       //             fileName: file?.name,
    //       //             fileStoreId: uploadedFile,
    //       //         },
    //       //     ]
    //       //     : null,
    //     }
    //     const appData = {
    //       ...applicationData,
    //       documents: getDocuments(),
    //       additionalDetails,
    //       workflow,
    //       action: currentAction?.action,
    //       comment: developerRemarks,
    //       assignee: null,
    //       // wfDocuments: uploadedFile
    //       //     ? [
    //       //         {
    //       //             documentType: currentAction + " DOC",
    //       //             fileName: file?.name,
    //       //             fileStoreId: uploadedFile,
    //       //         },
    //       //     ]
    //       //     : null,
    //     };
    //     submitAction({
    //       BPA: appData,
    //     });
    //   }
    // }
  
  console.log("dfygbhusw",formData );
   



    return (
      <React.Fragment>
        
              <Form12ApplicaionFormatView
                formData={formData}
                applicationDocs={applicationDocs}
                totalAmount={totalAmount}
                edcrDetails={edcrDetails}
                collectionBillDetails={collectionBillDetails}
              />
  
       
      
  
      </React.Fragment>
    );
  };
  
  export default Form12SummaryView;